import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSmile } from '@fortawesome/pro-regular-svg-icons/faSmile';

export default () => <FontAwesomeIcon icon={faSmile} />;
